<template lang="html">
  <div class="detail">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content container">
        <div class="ibox-title ">
          <h5 class="text-center">会员登记申请</h5>
        </div>
        <div class="box">
          <form>
            <div class="row border-bottom">
              <div class="col-sm-3" style="position: relative; z-index: 10;">
                <div class="card" style="border:none;">
                  <div class="border" :data-titie="formData1.photo ? '' : '照片'"
                    :class="!formData1.photo ? 'minHeight' : ''">
                    <img class="card-img-top" :src="formData1.photo">
                  </div>
                  <div class="card-body">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="customFile" @change="uploadImage">
                      <label class="custom-file-label" for="customFile"
                        :data-avatar="formData1.photo ? '重新上传' : '上传图片'"></label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-sm-3">
                <div class="card" style="border:none;">
                  <div class="border" :class="!formData1.photo?'minHeight':''">
                    <img class="card-img-top" :src="formData1.photo">
                  </div>
                </div>
              </div> -->
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>姓名：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.name" placeholder="">
                    <!-- <span class="form-span">{{formData1.name}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">笔名/艺名：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.penname" placeholder="">
                    <!-- <span class="form-span">{{formData1.penname}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>身份证号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.idnumber" @input="idcardInput"
                      placeholder="" maxlength="18">
                    <!-- <span class="form-span">{{formData1.idnumber}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>性别：</label>
                  <div class="col-sm-8 alignCenter">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                        v-model="formData1.gender" value="1" :checked="formData1.gender == 1">
                      <label class="form-check-label" for="inlineRadio1">男</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                        v-model="formData1.gender" value="0" :checked="formData1.gender == 0">
                      <label class="form-check-label" for="inlineRadio2">女</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>出生日期：</label>
                  <div class="col-sm-8">
                    <birth-date ref="birthdate" @getBirthdate="getBirthdate"></birth-date>
                    <!-- <span class="form-span">{{ formData1.birthdate }}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>民族：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="formData1.nation">
                      <option value="">请选择民族</option>
                      <option v-for="item in nation" :value="item">{{ item }}</option>
                    </select>
                    <!-- <span class="form-span">{{formData1.nation}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>政治面貌：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="formData1.political">
                      <option value="">请选择政治面貌</option>
                      <option v-for="item in politicalBackground" :value="item.name">{{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>籍贯：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.birthplace" placeholder="">
                    <!-- <span class="form-span">{{formData1.birthplace}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>工作单位：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.employer" placeholder="">
                    <!-- <span class="form-span">{{formData1.employer}}</span> -->
                  </div>
                </div>
                <!-- <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>单位性质：</label>
                  <div class="col-sm-8">
                   <span class="form-span">{{formData1.employer}}</span>
                    <select class="form-control" v-model="formData1.employer_type">
                      <option value="">请选择单位性质</option>
                      <option :value="str" v-for="str in types.split('、')">{{ str }}</option>
                    </select>
                  </div>
                </div> -->
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label overflowAuto"><span
                      class="red">*</span>职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.position" placeholder="">
                    <!-- <span class="form-span">{{formData1.position}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>职称：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.positiontitle" placeholder="">
                    <!-- <span class="form-span">{{formData1.positiontitle}}</span> -->
                  </div>
                </div>

                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>申请协会：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="formData1.union"
                      @change="_openNotice($event)">
                      <option value="">请选择协会</option>
                      <option v-for="(item, index) in group" :value="item.title">{{ item.title }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row no-gutters" v-if="formData1.union == '青岛市文艺志愿者协会'">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>是否是协会会员：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="formData1.is_member">
                      <option value="非会员">非会员</option>
                      <option v-for="(item, index) in group" :value="item.title">{{ item.title }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>文化程度：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="formData1.education">
                      <option value="">请选择文化程度</option>
                      <option v-for="item in culture" :value="item">{{ item }}</option>
                    </select>
                    <!-- <span class="form-span">{{formData1.education}}</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row part border-bottom">
              <div class="col-sm-5">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label"><span class="red">*</span>通讯地址：</label>
                  <div class="col-sm-8 ">
                    <input type="text" class="form-control" v-model="formData1.address" placeholder="">
                    <!-- <span class="form-span address">{{formData1.address}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">邮编：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.postcode" placeholder="">
                    <!-- <span class="form-span">{{formData1.postcode}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">办公电话：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.officephone" placeholder="">
                    <!-- <span class="form-span">{{formData1.officephone}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">家庭电话：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.telephone" placeholder="">
                    <!-- <span class="form-span">{{formData1.telephone}}</span> -->
                  </div>
                </div>
              </div>
              <div class="col-sm-5 offset-sm-2">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label"><span class="red">*</span>微信号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.wechat" placeholder="">
                    <!-- <span class="form-span">{{formData1.wechat}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3   col-form-label"><span class="red">*</span>手机号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.mobile" placeholder="">
                    <!-- <span class="form-span">{{formData1.mobile}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">电子信箱或个人网页：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.email" placeholder="">
                    <!-- <span class="form-span">{{formData1.email}}</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row part border-bottom">
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">国家级会员：</label>
                  <div class="col-sm-8">
                    <month-picker v-if="formData1" v-bind:default="formData1.joindate_n"
                      v-on:getChildDate="catchChildDate1"></month-picker>
                    <!-- <span class="form-span">{{checkTime(formData1.joindate_n)}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">省级会员：</label>
                  <div class="col-sm-8">
                    <month-picker v-if="formData1" v-bind:default="formData1.joindate_p"
                      v-on:getChildDate="catchChildDate2"></month-picker>
                    <!-- <span class="form-span">{{checkTime(formData1.joindate_p)}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">市级会员：</label>
                  <div class="col-sm-8">
                    <month-picker v-if="formData1" v-bind:default="formData1.joindate_c"
                      v-on:getChildDate="catchChildDate3"></month-picker>
                    <!-- <span class="form-span">{{checkTime(formData1.joindate_c)}}</span> -->
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.mid_n" placeholder="">
                    <!-- <span class="form-span">{{formData1.mid_n}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.mid_p" placeholder="">
                    <!-- <span class="form-span">{{formData1.mid_p}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.mid_c" placeholder="">
                    <!-- <span class="form-span">{{formData1.mid_c}}</span> -->
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.posi_n" placeholder="">
                    <!-- <span class="form-span">{{formData1.posi_n}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.posi_p" placeholder="">
                    <!-- <span class="form-span">{{formData1.posi_p}}</span> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="formData1.posi_c" placeholder="">
                    <!-- <span class="form-span">{{formData1.posi_c}}</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row part step2">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 class="sub-tit"><span class="red">*</span>主要艺术成就及获奖情况：</h5>
                  </div>
                  <div class="col-sm-11" style="overflow-x: auto;">
                    <div class="">
                      <table class="table">
                        <thead class="">
                          <tr scope="row">
                            <th class="text-center" scope="col">时间</th>
                            <th class="text-center" scope="col">地点</th>
                            <th class="text-center" scope="col">主办单位</th>
                            <th class="text-center" scope="col">著作出版社</th>
                            <th class="text-center" scope="col">作品或获奖情况</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="formData2 && formData2.awards" class="text-center border-bottom"
                            v-for="(item, index) in formData2.awards">
                            <td style="width:20%;">
                              <div class="form-group position-relative" @click.stop.prevent="showDatepicker(index)">
                                <month-picker v-bind:default="item.date" v-bind:index="index"
                                  v-on:getChildDate="catchChildDate"></month-picker>
                                <!-- <input type="text" name="place" class="form-control" placeholder="" required="" v-model="item.date" readonly>
                                <date-picker v-bind:index="index" v-bind:show="datepickerShow[index]" v-on:getChildDate="catchChildDate"></date-picker> -->
                              </div>
                              <!-- {{item.date}} -->
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" name="place" class="form-control" placeholder="" required=""
                                  v-model="item.place">
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" name="place" class="form-control" placeholder="" required=""
                                  v-model="item.organizer">
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" name="place" class="form-control" placeholder="" required=""
                                  v-model="item.press">
                              </div>
                            </td>

                            <td>
                              <div class="form-group">
                                <input type="text" name="place" class="form-control" placeholder="" required=""
                                  v-model="item.awards">
                              </div>
                            </td>
                            <td><span class="remove" @click="removeStep2(index)">-</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="btn btn-secondary" @click="addStep2">
                      增加
                    </div>
                  </div>

                  <div class="row col-sm-12 upload-image">
                    <div class="col-sm-auto " v-if="!formData2.photos || !formData2.photos.length">
                      <div class="example-img fixedWidth">
                      </div>
                    </div>
                    <div class="col-sm-auto" v-for="(item, index) in formData2.photos">
                      <div class="example-img position-relative">
                        <img :src="item.path" alt="">
                        <span class="delPhoto" @click="removePhoto(index)">×</span>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="customFile" @change="photosUpload">
                        <label class="custom-file-label" for="customFile"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row part step2 border-top">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 class="sub-tit"><span class="red">*</span>主要经历：</h5>
                  </div>
                  <div class="col-sm-11" style="overflow-x: auto;">
                    <div class="">
                      <table class="table">
                        <thead class="">
                          <tr scope="row">
                            <th class="text-center" scope="col">起始年月</th>
                            <th class="text-center" scope="col">结束年月</th>
                            <th class="text-center" scope="col">主要经历</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="formData3.length" class="text-center" v-for="(item, index) in formData3">
                            <td>
                              <div class="form-group">
                                <month-picker v-if="formData3" v-bind:default="item.startdate" v-bind:index="index"
                                  v-on:getChildDate="catchStep3Start"></month-picker>
                                <!-- <input type="text" name="place" class="form-control" placeholder="" required="" v-model="item.startdate" > -->
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <month-picker v-if="formData3" v-bind:default="item.enddate" v-bind:index="index"
                                  v-on:getChildDate="catchStep3End"></month-picker>
                                <!-- <input type="text" name="place" class="form-control" placeholder="" required="" v-model="item.enddate" > -->
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" name="place" class="form-control" placeholder="" required=""
                                  v-model="item.exp">
                              </div>
                            </td>
                            <td><span class="remove" @click="removeStep3(index)">-</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="btn btn-secondary" @click="addStep3">
                      增加
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
    <div class="row justify-content-md-center">
      <div class="form-group" style="margin: 0 auto;">
        <div class="btn btn-primary" @click="save(1)">
          提交
        </div>
      </div>
    </div>
    <alert-model v-bind:func="alertFunc" v-bind:show="alertShow" v-on:close="catchClose"
      v-bind:msg="tips"></alert-model>


    <div class="mask" v-if="flag">
      <div class="joinNotice">
        <div class="joinNotice-container">
          <h3 class="text-center">申请{{ formData1.union }}须知</h3>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-sm-12 scroll border">
              <section v-html="rule"></section>


              <div class="row justify-content-md-center" style="margin-top:30px;">
                <div class="form-group">
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customControlValidation1" v-model="checked">
                    <label class="custom-control-label" for="customControlValidation1">我已阅读入会须知</label>
                  </div>
                </div>

              </div>
              <div class="row justify-content-md-center">
                <div class="form-group">
                  <div class="btn btn-primary" :class="!checked ? 'disabled' : ''" @click="agree">
                    同意并继续
                  </div>
                </div>
              </div>

            </div>



          </div>

        </div>
      </div>
    </div>

    <div class="mask" v-if="flag2">
      <div class="joinNotice">
        <div class="joinNotice-container">
          <h3 class="text-center">答题</h3>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-sm-12 scroll border">
              <div class="qbox">
                <div class="box-content">
                  <template v-for="(item, index) in qlist">
                    <p class="title">{{ index + 1 }}.{{ item.title }} </p>
                    <!-- 单选 -->
                    <ul class="options" style="padding: 0;">
                      <template v-for="(val, i) in item.options">
                        <li :class="{ active: item.word == letters[i] }" @click="radioSelected(item, i, val)">
                          {{ letters[i] }}.{{ val }}
                        </li>
                      </template>

                    </ul>

                    <p class="tips" v-if="item.show">正确答案是：{{ item.answer }}</p>
                  </template>

                </div>
              </div>


              <div class="row justify-content-md-center">
                <div class="form-group">
                  <div class="btn btn-primary" @click="submit_q">
                    提交
                  </div>
                </div>
              </div>

            </div>



          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import birthDate from './birthdate.vue'
import commonHeader from './header.vue'
import stepSecond from './step2.vue'
import stepThird from './step3.vue'
import mapPicker from './map.vue'
import alertModel from './alert.vue'
import monthPicker from './monthpicker.vue'
import datePicker from './datepicker.vue'
export default {
  components: {
    commonHeader,
    mapPicker,
    stepSecond,
    stepThird,
    alertModel,
    birthDate,
    monthPicker,
    datePicker
  },
  watch: {

  },
  data() {
    return {
      types: '党政机关、事业单位、国有企业、外资企业、私营企业、个体工商户、军队、学生、其他',
      datepickerShow: [false],
      formData1: {
        photo: '',
        name: '',
        penname: '',
        idnumber: '',
        gender : '1',
        birthdate: '',
        nation: '',
        political: '',
        birthplace: '',
        employer: '',
        employer_type: '',
        position: '',
        positiontitle: '',
        union: '',
        is_member:'非会员',
        education: '',
        address: '',
        postcode: '',
        officephone: '',
        telephone: '',
        email: '',
        wechat: '',
        mobile: '',
        joindate_n: '',
        mid_n: '',
        posi_n: '',
        joindate_p: '',
        mid_p: '',
        posi_p: '',
        joindate_c: '',
        mid_c: '',
        posi_c: '',
      },
      formData2: {awards: [], photos: []},
      formData3: [],
      nation: [],
      posiTitle: [],
      politicalBackground: [],
      culture: [],
      group: [],
      alertShow: false,
      tips: '',
      alertFunc: '',
      role: this.$store.state.user.role,
      cid: '',
      checked: false,
      flag: false,
      rule: '',
      flag2: false,
      qlist: [],
      cid: '',
      questions: '',
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T'],
      cats: [],

    }
  },
  methods: {
    _openNotice(event) {
      console.log(event)
      let val = event.target.value
      var cid
      this.group.filter(item => {
        if (item.title == val) {
          cid = item.cid
        }
      })

      this.cid = cid
      this.$axios.get("/api/wenlian/getrulenew?cid=" + cid).then(res => {
        this.rule = res.data.data
        this.flag = true
      })

    },
    agree() {
      if (this.checked) {
        this.flag = false
        this.checked = false
        if (!this.questions || !this.questions[this.cid + 7]) {
          this.flag2 = false
          return
        }
        this.qlist = this.questions[this.cid + 7]
        this.flag2 = true
      }
    },
    radioSelected: function (row, i, q) {
      row.value = q
      let word = q == 'input' ? 'input' : this.letters[i].toUpperCase()
      this.$set(row, "word", this.letters[i].toUpperCase())
      if (word != row.answer) {
        this.$set(row, "show", true)
      }

    },
    submit_q() {
      var flag = true
      this.qlist.find(item => {
        if (item.word != item.answer) {
          flag = false
        }
      })
      if (flag) {
        this.flag2 = false
      } else {
        this.alert('全部答对才可申请该协会')
      }
    },
    idcardInput() {
      if (this.formData1.idnumber.length >= 14) {
        var date = this.formData1.idnumber.substring(6, 14)
        this.$refs.birthdate.setTime(date.substring(0, 4), date.substring(4, 6), date.substring(6, 8));
      }
      if (this.formData1.idnumber.length >= 17) {
        var sex = this.formData1.idnumber.substring(16, 17);
        this.formData1.gender = sex % 2
      }
    },
    showDatepicker(index) {
      this.$set(this.datepickerShow, index, !this.datepickerShow[index])
    },
    catchChildDate(data) {
      this.formData2.awards[data.index].date = data.date
      this.$set(this.datepickerShow, data.index, false)
    },
    save(op) {
      let photos = []
      for (let i = 0; i < this.formData2.photos.length; i++) {
        photos.push(this.formData2.photos[i].path)
      }
      let id = this.$route.query.id
      let params = {
        data: this.formData1,
        photos: photos,
        awards: this.formData2.awards,
        resume: this.formData3
      }
      let config = {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
      this.$axios.post(`/api/wenlian/newadd`, params, config).then(res => {
        if (res.data.result == 1) {
          this.alert('提交成功', () => {
            this.$router.push('/')
          })
        } else {
            this.alert(res.data.msg)
        }
      })
    },
    catchStep3Start(date) {
      this.formData3[date.index].startdate = date.date
    },
    catchStep3End(date) {
      this.formData3[date.index].enddate = date.date
    },
    removePhoto(index) {
      this.formData2.photos.splice(index, 1)
    },
    addStep2() {
      this.datepickerShow.push(false)
      this.formData2.awards.push({
        date: '',
        place: '',
        organizer: '',
        press: '',
        awards: ''
      })
    },
    addStep3() {
      this.formData3.push({
        startdate: '',
        exp: '',
        enddate: ''
      })
    },
    removeStep2(index) {
      this.datepickerShow.splice(index, 1)
      this.formData2.awards.splice(index, 1)
    },
    removeStep3(index) {
      this.formData3.splice(index, 1)
    },
    getBirthdate(date) {
      if (this.formData1) {
        this.formData1.birthdate = date.birthdate
      }
    },
    catchChildDate1(date) {
      console.log(date)
      if (this.formData1) {
        this.formData1.joindate_n = date.date
      }
    },
    catchChildDate2(date) {
      console.log(date)
      // this.formData1.joindate_p = date.date
      if (this.formData1) {
        this.formData1.joindate_p = date.date
      }
    },
    catchChildDate3(date) {
      // this.formData1.joindate_c = date.date
      console.log(date)
      if (this.formData1) {
        this.formData1.joindate_c = date.date
      }
    },
    uploadImage(e) {
      this.loading = true
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$axios.post('/api/wenlian/upload', param, config)
        .then(res => {
          this.loading = false
          if (res.data.result === 1) {
            this.formData1.photo = res.data.url
            this.alert(res.data.msg)
          } else {
            this.alert(res.data.msg)
          }
        })
    },
    photosUpload(e) {
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$axios.post('/api/wenlian/upload', param, config)
        .then(res => {
          if (res.data.result === 1) {
            this.formData2.photos.push({ path: res.data.url })
            this.alert(res.data.msg)
          } else {
            this.alert(res.data.msg)
          }
        })
    },
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    checkTime(time) {
      let date = new Date(time)
      if (date.getTime()) {
        return time
      } else {
        return ''
      }
    },

  },
  mounted() {
    this.nation = nation
    this.politicalBackground = politicalBackground
    this.culture = culture
    this.group = group
    this.posiTitle = []
    const testJson = require('../../static/wenlian.json')
    console.log('testData', testJson.data.questions)
    this.questions = testJson.data.questions
    this.cats = testJson.data.cats

  }
}
</script>

<style lang="css" scoped>
.detail .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.detail .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}

.detail .btn-light {
  width: 200px;
}

.detail .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.detail .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.detail .part {
  padding: 20px 0;
}

.detail .border {
  width: 100%;
  position: relative;
  min-height: 360px;
  overflow: hidden;
}

.detail .border::after {
  content: attr(data-title);
  position: absolute;
  color: #999;
  font-size: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.detail .minHeight {
  min-height: 360px;
}

.detail .border img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  z-index: 9999;
  width: 100%;
  height: auto;
}

.detail .fullScreen {
  height: 100%;
}

.detail .page-link {
  color: #33434b;
}

.detail .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}

.detail .page-link.active {
  background: #f4f4f4;
}

.detail .custom-file-label::after {
  content: attr(data-avatar);
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}

.detail .custom-file-label {
  border: none;
}

.detail .red {
  color: red;
  margin: 0 5px;
}

.detail .form-group label {
  font-size: 15px;
  color: #33434b;
}

.detail input,
.detail select,
.detail option,
.detail .textarea,
.detail .form-check label {
  color: #33434b;
  font-size: 15px;
}

.detail .step2 .custom-file-label::after {
  content: "证明材料上传";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}

.detail .step2 .custom-file-label {
  border: none;
}

.detail .step2 .red {
  color: red;
  margin: 0 5px;
}

.detail .step2 .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}

.detail .step2 table td,
table th {
  color: #333;
}

.detail .step2 .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}

.detail .step2 .form-group {
  margin-bottom: 0;
}

.detail .step2 .upload-image {
  margin-top: 20px;
}

.detail .step2 .upload-image img {
  height: 150px;
  width: auto;
  z-index: 9999;
}

.detail .step2 .custom-file {
  margin-top: 0%;
}

.detail .step2 .example-img {
  height: 150px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  position: relative;
}

.detail .step2 .example-img:after {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #dee2e6;
  font-size: 50px;
}

.detail .step2 .border {
  min-height: auto;
}

.detail .step2 .border::after {
  content: "";
}

.detail .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}

.detail textarea {
  min-height: 200px;
}

.detail .form-span {
  line-height: 1.5;
  color: #33434b;
  font-size: 15px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #33434b;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.detail table {
  margin-bottom: 0;
}

.address {
  height: auto !important;
}

.overflowAuto {
  overflow: auto;
}

.remove {
  background: #18a689;
  color: #fff;
  width: 25px;
  height: 25px;
  line-height: 22px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  font-size: 25px;
  margin-top: 5px;
}

.detail .fixedWidth {
  width: 200px;
}

.detail .example-img>img {
  position: relative;
  z-index: 999;
}

.delPhoto {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 99999;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #f31a1a;
  color: #fff;
  line-height: 22px;
  text-align: center;
  font-size: 25px;
}

.form-control[readonly] {
  background: none !important;
}

@media screen and (max-width: 750px) {
  .col-form-label {
    text-align: left;
  }

  .table {
    width: 1400px;
  }

  .detail .step2 .upload-image {
    text-align: center;
  }

  .detail .step2 .upload-image .col-sm-auto {
    margin-bottom: 20px;
  }

  .detail .step2 .upload-image img {
    width: 100%;
    object-fit: cover;
  }
}






/* 弹出框 */
.mask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}

.joinNotice {
  background-color: #fff;
  padding: 40px 0;
  position: fixed;
  width: 50vw;
  height: 80vh;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.joinNotice .joinNotice-container {
  height: 100%;
}

.joinNotice .joinNotice-container .row {
  margin-right: 0px;
  margin-left: 0px;
  padding: 0 10px;
  /* height: 100%; */
}

.joinNotice .scroll {
  height: calc(80vh - 120px);
  overflow-y: scroll;
  border-radius: 5px;
  background: #fff;
  margin-top: 20px;
  padding: 40px;
  font-size: 15px;
  line-height: 26px;
  color: #33434b;
  max-height: fit-content;
  min-height: auto;
}

.joinNotice .scroll p {
  text-indent: 2rem;
  font-size: 14px;
  line-height: 1.5;
}

.joinNotice .justify-content-md-center {
  -ms-flex-pack: center !important;
  -webkit-box-pack: center !important;
  justify-content: center !important;
}

.joinNotice .custom-control-input:checked~.custom-control-label::before {
  border-color: #1ab394;
  background-color: #1ab394;
}

.joinNotice .form-group {
  margin-bottom: 0;
}

.joinNotice .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}

.joinNotice .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.joinNotice .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

/* 答题 */
.qbox {
  width: 100%;
}

.box-content {}

.box-content .title {
  font-size: 16px !important;
  text-align: justify !important;
  line-height: 1.5;
  text-indent: 0 !important;
}

.box-content .options li {
  font-size: 16px;
  color: #333;
  border-radius: 10px;
  border: 1px solid #ced8ea;
  margin-top: 15px;
  padding: 15px;
  list-style: none;
}

.box-content .options .active {
  color: #0fbcea;
  box-shadow: 0px 5px 10px 0px rgba(157, 195, 250, 0.3);
  border: 2px solid #0fbcea;
}

.box-content .tips {
  font-size: 16px;
  color: #1ab394;
  line-height: 0.21rem;
  text-indent: 0 !important;
  /* background: url("../images/icon_tips.png") no-repeat;
  background-size: 0.15rem auto;
  background-position: left 0.05rem;
  padding-left: 0.2rem; */
  margin-top: 0.2rem;
  text-align: justify;
}

.step2 .custom-file-label::after {
  content: '证明材料上传';
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}

.step2 .custom-file-label {
  border: none;
}

.step2 .red {
  color: red;
  margin: 0 5px;
}

.step2 .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}

.step2 table td,
table th {
  color: #333;
}

.step2 .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}

.step2 .form-group {
  margin-bottom: 0;
}

.step2 .upload-image {
  margin-top: 20px;
}

.step2 .upload-image img {
  height: 150px;
  width: auto;
  z-index: 9999;
}

.step2 .custom-file {
  margin-top: 0%;
}

.step2 .example-img {
  height: 150px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  position: relative;
}

.fixedWidth {
  width: 200px;
}

.step2 .example-img:after {
  content: '+';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #dee2e6;
  font-size: 50px;
}

.step2 .border {
  min-height: auto;
}

.step2 .border::after {
  content: '';
}

.remove {
  background: #18a689;
  color: #fff;
  width: 25px;
  height: 25px;
  line-height: 22px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  font-size: 25px;
  margin-top: 5px;
}

.delPhoto {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 99999;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #f31a1a;
  color: #fff;
  line-height: 22px;
  text-align: center;
  font-size: 25px;
}

.form-control[readonly] {
  background: none !important;
}

/* 弹出框 */

@media only screen and (max-width: 750px) {
  .apply .form-group label {
    text-align: left;
  }

  .joinNotice {
    width: 90vw;
  }

  .joinNotice .text-center {
    font-size: 18px;
  }

  .detail .step2 .custom-file-label::after {
    content: '证明材料上传';
    border-radius: 0.25rem;
    text-align: center;
    width: 100%;
    height: 100%;
  }

  .detail .step2 .custom-file-label {
    border: none;
  }

  .detail .step2 .red {
    color: red;
    margin: 0 5px;
  }

  .detail .step2 .sub-tit {
    color: #33434b;
    font-size: 16px;
    padding-left: 10px;
    margin-bottom: 15px;
  }

  .detail .step2 table td,
  table th {
    color: #333;
  }

  .step2 .table td,
  .table th {
    padding: 0.75rem;
    vertical-align: top;
    border-top: none;
  }

  .step2 .form-group {
    margin-bottom: 0;
  }

  .step2 .upload-image {
    margin-top: 20px;
  }

  .step2 .upload-image img {
    height: 150px;
    width: auto;
    z-index: 9999;
  }

  .step2 .custom-file {
    margin-top: 0%;
  }

  .step2 .example-img {
    height: 150px;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    position: relative;
  }

  .step2 .example-img:after {
    content: '+';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #dee2e6;
    font-size: 50px;
  }

  .step2 .border {
    min-height: auto;
  }

  .step2 .border::after {
    content: '';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apply.vue